import { IRanked } from "@shared/types";

export enum PositionStatus {
    Good = 1,
    Average = 0,
    Bad = -1
}

/*
calculate the position's of current client among other clients(hospitals) in best practice/kpi
if less than three clients are included in BP/KPI we can adequately evaluate the state so 
function return 0(average).
*/
export function getPositionStatus(row: IRanked): PositionStatus | null {
    if (!row.position || !row.number_of_hospitals) return null;

    const [good, avg] = [
        Math.floor(row.number_of_hospitals / 3),
        Math.floor((2 * row.number_of_hospitals) / 3)
    ];
    return row.position <= good
        ? PositionStatus.Good
        : row.position <= avg || row.number_of_hospitals < 3
        ? PositionStatus.Average
        : PositionStatus.Bad;
}

export function getPositionStatusColor(state: PositionStatus | null): string | null {
    return state === 1 ? "daf3f3" : state === -1 ? "fde9ec" : state === 0 ? "efefef" : null;
}
